/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplacementOptions
 */
export interface ReplacementOptions {
    /**
     * 
     * @type {boolean}
     * @memberof ReplacementOptions
     */
    useInitialInsteadOfFirst?: boolean | null;
}

export function ReplacementOptionsFromJSON(json: any): ReplacementOptions {
    return ReplacementOptionsFromJSONTyped(json, false);
}

export function ReplacementOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplacementOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'useInitialInsteadOfFirst': !exists(json, 'useInitialInsteadOfFirst') ? undefined : json['useInitialInsteadOfFirst'],
    };
}

export function ReplacementOptionsToJSON(value?: ReplacementOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'useInitialInsteadOfFirst': value.useInitialInsteadOfFirst,
    };
}


